import React from 'react';
import { Link } from 'react-router-dom';
import { AppRoutes } from './routesPath';

export const MessageWhenNoOffer = () => (
  <div>
    No offer?{' '}
    <Link to={AppRoutes.OffersCreate} target='__blank'>
      Click here to create one
    </Link>
  </div>
);
export const MessageWhenNoCreative = () => (
  <div>
    No creative?{' '}
    <Link to={AppRoutes.CreativeComposeCreate} target='__blank'>
      Click here to create one
    </Link>
  </div>
);
export const MessageWhenNoDomain = () => (
  <div>
    No domain group? Search again or{' '}
    <Link to={AppRoutes.DomainGroups}>Click here to create new group</Link>
  </div>
);

export const MessageWhenNoUser = () => {
  return <div>No user found !</div>;
};

export const messageLockContactRunning =
  'Can not process as campaign is running. Please try again.';

export const REQUIRED_FIELD = (field) => `${field} is required field!`;
export const MUST_SELECTED_FIELD = (field) => `${field} must be selected!`;
export const NUMBER_FIELD = (field) => `${field} must be number type!`;
export const INCORRECT_FORMAT = (field) => `${field} is incorrect format!`;
export const IS_NUMBER_TYPE = (field) => `${field} must be number type!`;
export const STRING_LENGTH_MIN = (field, number = 0) =>
  `${field} must be at least ${number} character(s)!`;
export const STRING_LENGTH_MAX = (field, number = 0) =>
  `${field} must be lesser ${number} character(s)!`;

export const MUST_BE_NUMBER = (field) => `${field} must be number type!`;
export const MUST_BE_INTEGER_NUMBER = (field) => `${field} must be integer number`;
export const MUST_BE_POSITIVE_NUMBER = (field) => `${field} must be positive number`;
export const MUST_BE_LARGER_THAN = (field, number = 0) => `${field} must be larger than ${number}`;
export const MUST_BE_LARGER_OR_EQUAL_THAN = (field, number = 0) =>
  `${field} must be equal or larger than ${number}`;

export const MUST_BE_LESS_OR_EQUAL_THAN = (field, number = 0) =>
  `${field} must be less or equal than ${number}`;

export const MESSAGE_NO_CONTACT_TARGET =
  'This file did not send messages because no contacts matched your desired targeting options';

export const MUST_BE_EQUAL_OR_LARGER_THAN = (field, min) =>
  `${field} must be larger than or equal to ${min} char(s)`;

export const MUST_BE_SMALLER_OR_EQUAL_THAN = (field, max) =>
  `${field} must be less than or equal to ${max} char(s)`;

export const MUST_BE_IN_RANGE = (field, { min, max }) =>
  `${field} must be in range ${min} -> ${max}`;
